import { renderStatusCell } from 'ui/table/StatusCell';

export const AccessStateCell = renderStatusCell({
    ACTIVE: 'green',
    PENDING: 'yellow',
    REVOKED: 'red'
});
